module.exports = __webpack_public_path__ + "img/wusong-night.1a0533d3.png";